import axios from 'axios';
import { authHeader } from './authHeader'; 

const API_URL = process.env.REACT_APP_API_URL; 

const getTemplates = (params) => {
    return axios.get(`${API_URL}/api/templates`, {
        params: params,
        headers: authHeader(),
    });
};

const getTemplateById = async (id) => {
    const response = await axios.get(`${API_URL}/api/templates/${id}`, {
        headers: authHeader(),
    });
    return response.data;
};

const addTemplate = async (formData) => {
    const response = await axios.post(`${API_URL}/api/templates`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const updateTemplate = async (id, formData) => {
    const response = await axios.put(`${API_URL}/api/templates/update/${id}`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const deleteTemplate = async (id) => {
    const response = await axios.delete(`${API_URL}/api/templates/delete/${id}`, {
        headers: authHeader(),
    });
    return response.data;
};

const getTag = (params) => {
    return axios.get(`${API_URL}/api/tags`, {
        params: params,
        headers: authHeader(),
    });
};



const addTag = async (formData) => {
    const response = await axios.post(`${API_URL}/api/tags/`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const updateTag = async (id, formData) => {
    const response = await axios.put(`${API_URL}/api/tags/${id}`, formData, {
        headers: authHeader(),
    });
    return response.data;
};

const deleteTag = async (id) => {
    const response = await axios.delete(`${API_URL}/api/tags/${id}`, {
        headers: authHeader(),
    });
    return response.data;
};



const ShowcaseAPI = {
    getTemplates,
    getTemplateById,
    addTemplate,
    updateTemplate,
    deleteTemplate,
    getTag,
    updateTag,
    addTag,
    deleteTag
};

export default ShowcaseAPI;
